

/**
 * @description 判斷是否為H5
 */
export function _isMobile() {
  return navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
}

/**
 * @description 判斷是否為APP
 */
export function _isApp() {
  return navigator.userAgent.match(/(great-winner)/i)
}

/**
 * @description 檢查data型態
 */
export function checkType(data) {
  return Object.prototype.toString.call(data)
}


/**
 * @description 字串转JSON
 */
export function stringToJSON(stringVal, defaultVal = '') {
  try {
    return JSON.parse(stringVal)
  } catch(e) {
    return defaultVal
  }
}

/**
 * @description 取得 cookie
 */
export function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
}
